import { createSelector } from '@reduxjs/toolkit';
import { PlacesState } from './types';

const selectBase = createSelector(
	(state: RootState) => state,
	(state: RootState) => state.placesReducer,
);

export const selectPlaces = createSelector(
	selectBase,
	(state: PlacesState) => state.places,
);

export const selectPlacesNames = createSelector(
	selectBase,
	(state: PlacesState) => {
		const map = new Map();
		state.places.forEach(place => {
			map.set(place.id, place.name);
		});

		return map;
	},
);
